import React from 'react';
import c from 'classnames';
import s from './ModalFooter.scss';
/**
 * The bottom portion of a modal. It has slots for it's left and right sides.
 */
var ModalFooter = function (_a) {
    var className = _a.className, _b = _a.left, left = _b === void 0 ? [] : _b, _c = _a.right, right = _c === void 0 ? [] : _c;
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement("div", { className: s['left'] }, left.map(function (item, index) {
            return item && (React.createElement("div", { key: "footer-item-" + index, className: s['left-side-item-wrapper'] }, item));
        })),
        React.createElement("div", { className: s['right'] }, right.map(function (item, index) {
            return item && (React.createElement("div", { key: "footer-item-" + index, className: s['right-side-item-wrapper'] }, item));
        }))));
};
ModalFooter.displayName = 'ModalFooter';
export default ModalFooter;
//# sourceMappingURL=ModalFooter.js.map